import Form from "react-bootstrap/Form";
import React, { useEffect, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import { useOrderFilterData } from "./store";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Filter from "assets/svgs/filter/Filter";
import { Select, Space, Badge } from "antd";
import { isEmpty } from "lodash";
import { convertDateformat, formatDate, formateQueryDate } from "modules/utilities/utility";

function OffCanvas({ name, ...props }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [show, setShow] = useState(false);
  const [bulk, setBulk] = useState("");
  const [subscription, setSubscription] = useState("");
  const [status, setStatus] = useState(null);
  const [subStatus, setSubStatus] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const [orderSource, setOrderSource] = useState(null);
  const [repeat, setRepeat] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [combo, setCombo] = useState(null);
  const [owner, setOwner] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const { doctorData, fetchDoctorData } = useOrderFilterData();
  const startDateFilter = searchParams.get("startDate");
  const endDateFilter = searchParams.get("endDate");
  const bulkFilter = searchParams.get("isBulk");
  const subscriptionFilter = searchParams.get("isSubscription");
  const statusFilter = searchParams.get("status");
  const subStatusFilter = searchParams.get("subStatus");
  const doctorFilter = searchParams.get("doctors");
  const orderSourceFilter = searchParams.get("orderSource");
  const repeatFilter = searchParams.get("orderType");
  const orderTypeFilter = searchParams.get("orderSourceType");
  const comboFilter = searchParams.get("isCombo");
  const pathName = window.location.pathname;

  const urlData = useMemo(() => {
    const query = window.location.href;
    return query.split("?")[1];
  }, [location]);

  const url = useMemo(() => {
    return urlData;
  }, [urlData]);

  const params = new URLSearchParams(url);
  params.delete("pageNumber");
  const updatedQueryString = params.toString();

  useEffect(() => {
    fetchDoctorData();
  }, []);

  // const formateQueryDate = (date) => {
  //   return format(date, "yyyy-MM-dd");
  // };

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    let queryParams = "";

    if (startDate) {
      queryParams += `&startDate=${formateQueryDate(startDate)}`;
    }
    if (endDate) {
      queryParams += `&endDate=${formateQueryDate(endDate)}`;
    }
    if (bulk) {
      queryParams += `&isBulk=${bulk}`;
    }
    if (subscription) {
      queryParams += `&isSubscription=${subscription}`;
    }
    if (status) {
      queryParams += `&status=${status}`;
    }
    if (subStatus) {
      queryParams += `&subStatus=${subStatus}`;
    }
    if (doctor) {
      queryParams += `&doctors=${doctor}`;
    }
    if (orderSource) {
      queryParams += `&orderSource=${orderSource}`;
    }
    if (repeat) {
      queryParams += `&orderType=${repeat}`;
    }
    if (owner && pathName.includes("allOrder")) {
      queryParams += `&assignedTo=${owner}`;
    }
    if (orderType) {
      queryParams += `&orderSourceType=${orderType}`;
    }
    if (combo) {
      queryParams += `&isCombo=${combo}`;
    }
    if (pathName.includes("allOrder")) {
      navigate(`/order-management/allOrder?pageNumber=1${queryParams}`);
    } else if (pathName.includes("open_orders")) {
      navigate(`/order-management/open_orders?pageNumber=1${queryParams}`);
    } else {
      props.setPageNumber(1);
      props.setQueryParams(queryParams);
      props.setClear(0);
    }

    setTimeout(() => {
      setShow(false);
    }, 1000);
  };

  const handleClear = () => {
    if (pathName.includes("allOrder")) {
      navigate(`/order-management/allOrder?pageNumber=1`);
    } else if (pathName.includes("open_orders")) {
      navigate(`/order-management/open_orders?pageNumber=1`);
    } else {
      props.setQueryParams("");
      props.setPageNumber(1);
      props.setClear(1);
      urlNavigateData();
    }
    setShow(false);

    setStartDate("");
    setEndDate("");
    setBulk("");
    setSubscription("");
    setStatus("");
    setSubStatus("");
    setDoctor("");
    setOrderSource("");
    setRepeat("");
    setOrderType("");
    setCombo("");
  };

  const urlNavigateData = () => {
    navigate("/dashboard/home/assigned-orders?pageNumber=1");
  };

  const handleStartDateChange = (data) => {
    setStartDate(data);
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
  };

  const handleResetStartDate = () => {
    setStartDate(null);
  };
  const handleResetEndDate = () => {
    setEndDate(null);
  };

  // const formatDate = (date) => {
  //   return format(date, "dd-MM-yyyy");
  // };

  // function convertDateFormat(inputDate) {
  //   if (inputDate) {
  //     const [year, month, day] = inputDate.split("-");
  //     const outputDate = `${day}-${month}-${year}`;
  //     return outputDate;
  //   }
  // }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div
        onClick={handleShow}
        className={
          pathName.includes("allOrder")
            ? "mt-1 text-primary cursor-pointer "
            : "me-2 mt-2 text-primary cursor-pointer "
        }
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fw-bold">Order filter</div>
            </Tooltip>
          }
        >
          <span>
            <Filter />
          </span>
        </OverlayTrigger>
      </div>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="fs-1">Traya</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {updatedQueryString ? (
            <div className="fw-bold ms-3">
              Please, Click clear button to reset filter or Filter Again
            </div>
          ) : null}
          <Form
            onSubmit={handleFilterSubmit}
            className="data-filter"
            style={{ mrginBottom: "20rem" }}
          >
            <div className="d-flex flex-column gap-3">
              <div className="d-flex flex-column gap-1">
                <Form.Label className="mx-3">Start Date:</Form.Label>
                <Form.Group className="mx-3">
                  <DatePicker
                    selected={startDate}
                    onChange={handleStartDateChange}
                    placeholderText="Start Date"
                    dateFormat="dd-MM-yyyy"
                    value={
                      startDateFilter || startDate
                        ? convertDateformat(startDateFilter) ||
                          formatDate(startDate)
                        : ""
                    }
                    maxDate={new Date()}

                    className="input-with-icon form-control"
                    style={{ width: "15rem" }}
                  />
                </Form.Group>
                <Form.Group className="mx-3">
                  <Form.Label className="">End Date:</Form.Label>
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    placeholderText="End Date"
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    value={
                      endDateFilter || endDate
                        ? convertDateformat(endDateFilter) ||
                          formatDate(endDate)
                        : ""
                    }
                    maxDate={new Date()}
                    minDate={startDate ? new Date(startDate) : null} 
    
                  />
                </Form.Group>
              </div>
              <Form.Group className="mt-n3 m-3">
                <label htmlFor="bulk">Bulk Order</label>
                <Form.Select
                  id="bulk"
                  onChange={(event) => setBulk(event.target.value)}
                  value={bulkFilter || bulk}
                >
                  <option
                    className={bulkFilter ? "" : "d-none"}
                    value={bulkFilter ? bulkFilter : ""}
                  >
                    {bulkFilter || ""}
                  </option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="subscription">Subscription</label>
                <Form.Select
                  id="subscription"
                  onChange={(event) => setSubscription(event.target.value)}
                  value={subscriptionFilter || subscription}
                >
                  <option
                    className={subscriptionFilter ? "" : "d-none"}
                    value={subscriptionFilter ? subscriptionFilter : ""}
                  >
                    {subscriptionFilter || ""}
                  </option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="orderStatus">Order Status</label>
                <Form.Select
                  id="orderStatus"
                  onChange={(event) => setStatus(event.target.value)}
                  value={status}
                >
                  <option
                    className={statusFilter ? "" : "d-none"}
                    value={statusFilter ? statusFilter : ""}
                  >
                    {statusFilter || ""}
                  </option>
                  {optionsStatus?.map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="subStatus">Order Sub Status</label>
                <Form.Select
                  id="subStatus"
                  onChange={(event) => setSubStatus(event.target.value)}
                  value={subStatus}
                >
                  <option
                    className={subStatusFilter ? "" : "d-none"}
                    value={subStatusFilter ? subStatusFilter : ""}
                  >
                    {subStatusFilter || ""}
                  </option>
                  {optionsSubStatus?.map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="doctors">Doctors</label>
                <Form.Select
                  id="doctors"
                  onChange={(event) => setDoctor(event.target.value)}
                >
                  <option
                    className={doctorFilter ? "" : "d-none"}
                    value={doctorFilter ? doctorFilter : ""}
                  >
                    {doctorFilter || ""}
                  </option>
                  {doctorData &&
                    doctorData?.userRole?.map((option) => (
                      <option key={option?.user?.id} value={option?.user?.id}>
                        {option?.user?.first_name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="orderSource">Order Source</label>
                <Form.Select
                  id="orderSource"
                  onChange={(event) => setOrderSource(event.target.value)}
                >
                  <option
                    className={orderSourceFilter ? "" : "d-none"}
                    value={orderSourceFilter ? orderSourceFilter : ""}
                  >
                    {orderSourceFilter || ""}
                  </option>
                  {optionsOrderSource?.map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="repeat">New/Repeat</label>
                <Form.Select
                  id="repeat"
                  onChange={(event) => setRepeat(event.target.value)}
                >
                  <option
                    className={repeatFilter ? "" : "d-none"}
                    value={repeatFilter ? repeatFilter : ""}
                  >
                    {repeatFilter || ""}
                  </option>
                  {optionsOrderType?.map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="orderType">Order Type</label>
                <Form.Select
                  id="orderType"
                  onChange={(event) => setOrderType(event.target.value)}
                >
                  <option
                    className={orderTypeFilter ? "" : "d-none"}
                    value={orderTypeFilter ? orderTypeFilter : ""}
                  >
                    {}
                  </option>
                  {codOrderTypeOptions?.map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {pathName.includes("allOrder") ||
              pathName.includes("open_orders") ? (
                <div className="m-3 mt-n2 mb-3 my-2">
                  <div className="fw-bold mt-n2 ms-1">Owner</div>
                  <Select
                    allowClear
                    dropdownStyle={{ minWidth: 240 }}
                    onChange={(e) => (e ? setOwner(e) : setOwner(undefined))}
                    optionFilterProp="label"
                    placeholder="Owner"
                    showSearch
                    className="w-100"
                  >
                    {!isEmpty(props.medicalReps) &&
                      props.medicalReps?.userRole?.map((rep) => (
                        <Option
                          label={rep.user.first_name}
                          value={rep.user.id}
                          key={rep.user.id}
                        >
                          <Space align="center">
                            <div>{rep.user.first_name}</div>
                            <Badge
                              count="Medical Rep"
                              style={{
                                backgroundColor: "#f1f1f1",
                                color: "#313131",
                              }}
                            />
                          </Space>
                        </Option>
                      ))}

                    {!isEmpty(props.consultReps) &&
                      props.consultReps?.userRole?.map((rep) => (
                        <Option
                          label={rep.user.first_name}
                          value={rep.user.id}
                          key={rep.user.id}
                        >
                          <Space align="center">
                            <div>{rep.user.first_name}</div>
                            <Badge
                              count="Consult Rep"
                              style={{
                                backgroundColor: "#f1f1f1",
                                color: "#313131",
                              }}
                            />
                          </Space>
                        </Option>
                      ))}

                    <Option label="N/A" value="NA">
                      <Space align="center">
                        <div>N/A</div>
                        <Badge
                          count="Not Assigned"
                          style={{
                            backgroundColor: "#f1f1f1",
                            color: "#313131",
                          }}
                        />
                      </Space>
                    </Option>
                  </Select>
                </div>
              ) : null}
              <Form.Group className="mt-n4 m-3">
                <label htmlFor="comboOrder">Combo Order</label>
                <Form.Select
                  id="comboOrder"
                  onChange={(event) => setCombo(event.target.value)}
                >
                  <option
                    className={comboFilter ? "" : "d-none"}
                    value={comboFilter ? comboFilter : ""}
                  >
                    {comboFilter || ""}
                  </option>
                  <option value="true">True</option>
                  <option value="true">False</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="d-flex gap-4 justify-content-between mb-5 mx-3">
              <Button
                variant="primary"
                className="mt-4"
                type="submit"
                // onClick={handleSubmit}
                style={{ width: "10rem" }}
              >
                Apply
              </Button>
              <Button
                variant="primary"
                className="mt-4"
                onClick={handleClear}
                style={{ width: "10rem" }}
              >
                Clear
              </Button>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function AssignedOrderFilter({
  setQueryParams,
  setPageNumber,
  setClear,
  medicalReps,
  consultReps,
}) {
  return (
    <>
      <OffCanvas
        key={6}
        placement={"end"}
        setQueryParams={setQueryParams}
        setPageNumber={setPageNumber}
        setClear={setClear}
        medicalReps={medicalReps}
        consultReps={consultReps}
      />
    </>
  );
}

export default AssignedOrderFilter;

const optionsStatus = [
  { label: "Delivered", value: "delivered" },
  { label: "Ghost", value: "ghost" },
  { label: "In Progress", value: "in_progress" },
  { label: "Pending", value: "pending" },
  { label: "Pending Prescription", value: "pending_prescription" },
  { label: "Shipping Pending", value: "shipping_pending" },
  { label: "Shipped", value: "shipped" },
  { label: "Unknown", value: "unknown" },
  { label: "Void", value: "void" },
];

const optionsSubStatus = [
  { label: "Delivered", value: "Delivered" },
  { label: "Failed Delivery", value: "FailedDelivery" },
  { label: "In Transit", value: "InTransit" },
  { label: "Not Serviceable", value: "NotServiceable" },
  { label: "Out For Delivery", value: "OutForDelivery" },
  { label: "RTO", value: "rto" },
  { label: "RTO InTransit", value: "RTO-InTransit" },
  { label: "RTO Marked", value: "RTO-Marked" },
  { label: "RTO Failed", value: "RTO-Failed" },
  { label: "Shipment Delayed", value: "ShipmentDelayed" },
  { label: "PickedUp", value: "PickedUp" },
  { label: "Undelivered", value: "undelivered" }
];

const optionsOrderSource = [
  { label: "CRM", value: "crm" },
  { label: "Hair Coach", value: "hair_coach" },
  { label: "Website", value: "website" },
  { label: "Waba Campaign", value: "waba_campaign" },
];

const optionsOrderType = [
  { label: "New", value: "new" },
  { label: "Repeat", value: "repeat" },
];

const codOrderTypeOptions = [
  { label: "Cod Approved", value: "cod_approved" },
  { label: "Cod Pending", value: "cod_pending" },
  { label: "Cod Rejected", value: "cod_rejected" },
  { label: "General", value: "general" },
  { label: "Pre Paid", value: "pre_paid" },
  { label: "Other", value: "other" },
];
